'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('NextSystemToReviewController', ['$scope', '$state', 'authUser', 'authLogin', 'accessReview', 'stateAccessReview', 'systemRoleID', 'systemsToReview', function ($scope, $state, authUser, authLogin, accessReview, stateAccessReview, systemRoleID, systemsToReview) {

    $scope.accessReview = accessReview;
    $scope.systemRoleID = systemRoleID;

    if (_.isEmpty($scope.accessReview)) {
        $state.go('accessReview.noAccessReview', null, { reload: true });
        return;
    }

    if (systemsToReview.length == 0) {
        $state.go('accessReview.noAccessReviewForEmployee', null, { reload: true });
        return;
    }

    if (stateAccessReview.StateName === 'Submitted' && !$state.is('accessReview.authUser.submitted') && !authUser.IsInAdministrationGroup) {
        $state.go('accessReview.authUser.submitted', null, { reload: true });
        return;
    }

    if ($state.is('accessReview.authUser.systemToReview')) {
        if (_.isUndefined(systemRoleID) || _.isNull(systemRoleID)) {
            $state.transitionTo('accessReview.authUser.systemToReview.summary',
                        { authLogin: authLogin },
                        {
                            reload: true,
                            inherit: false
                        });
            return;
        }

        if (stateAccessReview.StateName === 'NotStarted') {
            $state.go('accessReview.authUser.welcome', 
                      { authLogin: authLogin },
                      { reload: true });
            return;
        }

        $state.transitionTo('accessReview.authUser.systemToReview.systemRole',
                    {
                        authLogin: authLogin,
                        systemRoleID: $scope.systemRoleID
                    }, {
                        reload: true,
                        inherit: false
                    });
        return;
    }
}]);
